import { render, staticRenderFns } from "./update-email-address.vue?vue&type=template&id=70e18eaa&"
import script from "./update-email-address.vue?vue&type=script&lang=js&"
export * from "./update-email-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports